import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainStorySection } from './components/PainStorySection';
import { IntroductionSection } from './components/IntroductionSection';
import { SilentDeathSection } from './components/SilentDeathSection';
import { BreakingPointSection } from './components/BreakingPointSection';
import { DiscoverySection } from './components/DiscoverySection';
import { TransformationSection } from './components/TransformationSection';
import { SocialProofSection } from './components/SocialProofSection';
import { UrgencySection } from './components/UrgencySection';
import { ObjectionSection } from './components/ObjectionSection';
import { OfferSection } from './components/OfferSection';
import { CTASection } from './components/CTASection';
import { FinalSection } from './components/FinalSection';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show floating CTA after scrolling past hero section
      if (window.scrollY > window.innerHeight) {
        setShowFloatingCTA(true);
      } else {
        setShowFloatingCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <div className="w-full max-w-[1200px] mx-auto" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainStorySection data-id="element-3" />
        <IntroductionSection data-id="element-4" />
        <SilentDeathSection data-id="element-5" />
        <BreakingPointSection data-id="element-6" />
        <DiscoverySection data-id="element-7" />
        <TransformationSection data-id="element-8" />
        <SocialProofSection data-id="element-9" />
        <UrgencySection data-id="element-10" />
        <ObjectionSection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <CTASection data-id="element-13" />
        <FinalSection data-id="element-14" />
        {showFloatingCTA && <FloatingCTA data-id="element-15" />}
      </div>
    </div>;
}